import { useCallback, useEffect,useState } from "react";
import { v4 as uuidv4 } from "uuid";

import config from "@/config";
import fetchWrapper from "@/services/fetchWrapper.service";
import UserService from "@/services/user.service";
import { getStickerId } from "@/shared-components/stickers/utils";

import useStateHandler from "./useStateHandler";

export default function useMessages(conversationId) {
  const { state } = useStateHandler();
  const [sendMessageTrigger, setSendMessageTrigger] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [receiveMessageTrigger, setReceiveMessageTrigger] = useState({}); // TODO: WITH WEBSOCKETS
  const [messages, setMessages] = useState(null);
  const [loading, setLoading] = useState(messages ? false : true);

  useEffect(() => {
    if(!messages) {
      fetchWrapper.get(`${config.apis.api.url}/order/${conversationId}/chat?limit=25`, {
        injectToken: true
      })
        .then(({ response, data }) => {
          if(response.ok) {
            const newMessages = {
              ...data,
              data: data.data.reverse()
            };

            setLoading(false);
            setMessages(newMessages);
          }
        });
    }
  }, []);

  function loadMoreMessages() {
    fetchWrapper.get(`${config.apis.api.url}/order/${conversationId}/chat?offset=${messages.data.length}&limit=25`, {
      injectToken: true
    }).then(({ response, data }) => {
      if(response.ok) {
        const newMessages = {
          ...messages,
          data: [
            ...data.data.reverse(),
            ...messages.data,
          ]
        };

        setLoading(false);
        setMessages(newMessages);
      }
    });
  }

  function sendMessage(messagePayload) {
    if(loading) return;

    const normalizedPayload = typeof messagePayload === "string"
      ? { text: messagePayload }
      : (messagePayload || {});

    const messageText = typeof normalizedPayload.text === "string"
      ? normalizedPayload.text.trim()
      : "";
    const stickerPayload = normalizedPayload.sticker;
    const stickerId = getStickerId(stickerPayload);

    if(!messageText && !stickerId) return;

    const messageCreated = {
      _id: uuidv4(),
      message_sender: state.user_session,
      createdAt: Date.now(),
    };

    if(messageText) {
      messageCreated.message_text = messageText;
    }

    if(stickerPayload && stickerId) {
      messageCreated.message_sticker = stickerPayload;
    }

    const previousMessages = messages || { totalDocs: 0, data: [] };

    const newMessages = {
      ...previousMessages,
      totalDocs: (previousMessages.totalDocs || 0) + 1,
      data: [
        ...(previousMessages.data || []),
        messageCreated
      ]
    };

    setMessages(newMessages);
    setSendMessageTrigger({});

    UserService.sendMessage(conversationId, {
      text: messageText || undefined,
      stickerId
    });
  }

  const markMessagesAsRead = useCallback(async () => {
    const { response, data } = await fetchWrapper.post(
      `${config.apis.api.url}/order/${conversationId}/chat/read`,
      { injectToken: true }
    );
    return response.ok ? (data?.markedCount || 0) : 0;
  }, [conversationId]);

  return {
    loading,
    messages,
    loadMoreMessages,
    sendMessage,
    sendMessageTrigger,
    receiveMessageTrigger,
    markMessagesAsRead,
  };
}
